export const ADMIN_AFFILIATE_TRACKERS_SETTINGS_ROUTE_NAME = Symbol('admin.affiliates.approved.trackers-settings');
export const TRANSLATION_GROUP_AFFILIATES_TRACKERS_SETTINGS = Symbol('admin.affiliates.approved.trackers-settings');
